<app-confirm-action-modal
  testId="duplicate-campaign-dialog"
  title="Create Duplicate?"
  [message]="
    'Are you sure you want to duplicate this campaign? This action will create a copy of the campaign \'' +
    (campaign?.name || 'this campaign') +
    '\' Do you want to continue?'
  "
  confirmLabel="Yes, Duplicate"
  (confirm)="onConfirmDuplicate()"
  (cancel)="onClose()"
></app-confirm-action-modal>
